import { saveAs } from 'file-saver';
import { auth } from './firebase';

export async function downloadResume(resumeId: string): Promise<void> {
  try {
    const idToken = await auth?.currentUser?.getIdToken(true);
    const res = await fetch(`/assets-api/v2/pdf/${resumeId}`, {
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    });
    const contentDisposition = res.headers.get('content-disposition');
    const blob: Blob = await res.blob();
    saveAs(blob, getFilename(contentDisposition));
  } catch (error) {
    console.log('Error fetching resume', error);
    throw new Error('Unable to download resume');
  }
}

function getFilename(contentDisposition: string | null) {
  const FALLBACK_FILENAME = 'resume.pdf';

  if (!contentDisposition) return FALLBACK_FILENAME;

  try {
    return contentDisposition.split('filename=')[1].replace(/"/g, '');
  } catch (e) {
    return FALLBACK_FILENAME;
  }
}
